import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PageWithFiltersEnum } from 'src/app/models/filters/pageWithFilters.enum';
import { FiltersService } from 'src/app/services/filters/filters.service';
import { FiltersQueryTransformer } from 'src/app/services/filters/filtersQueryTransformer.ts/filtersQueryTransformer';

import { QueryParamsService } from 'src/app/services/queryParams/query-params.service';

@Component({
  selector: 'app-playbooks',
  templateUrl: './playbooks.component.html',
  styleUrls: ['./playbooks.component.scss'],
})
export class PlaybooksComponent implements OnInit {
  public object = Object;

  public tabs = [
    { name: 'yourPlaybooks', labelPath: 'playbooks.yourPlaybooks' },
    { name: 'Marketplace', labelPath: 'playbooks.marketplace' },
    { name: 'executionHistory', labelPath: 'playbooks.executionHistory' },
  ];

  public currentTabIndex = 0;

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
    private readonly _queryParamsService: QueryParamsService,
    private readonly _filterService: FiltersService
  ) {}

  ngOnInit(): void {
    this._route.queryParams.subscribe((params) => {
      const newTabIndex = this.tabs.findIndex((tab) => tab.name == params['tab']);
      this.currentTabIndex = newTabIndex != -1 ? newTabIndex : 0;
    });
  }

  public onTabSelection(selectedTab: number) {
    let query: string | undefined = undefined;

    if (selectedTab == 0) {
      query = FiltersQueryTransformer.transformToQuery(
        this._filterService.getFilters(PageWithFiltersEnum.Playbooks).getSelectedFilters()
      );
    }

    if (selectedTab == 2) {
      query = FiltersQueryTransformer.transformToQuery(
        this._filterService.getFilters(PageWithFiltersEnum.Executions).getSelectedFilters()
      );
    }

    this.currentTabIndex = selectedTab;

    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: {
        tab: this.tabs[this.currentTabIndex].name,
        q: query,
      },
      queryParamsHandling: 'merge',
    });
  }
}
